module.exports = __webpack_public_path__ + "static/media/layout-bg.45948afc.jpg";